module.exports = __webpack_public_path__ + "static/media/YoGabbaGabbaFinal.53e8bef2.jpg";